import { HttpClient } from 'api/http-client';
import { Field } from 'api/tasks';
import { AccountFields } from 'data/fields/hooks';

function getUrl(fieldId: number) {
  return `/tasks/fields/${fieldId}`;
}

class TaskFieldsHttpClient extends HttpClient {
  public async getTaskFields(): Promise<AccountFields> {
    return this.get<AccountFields>('/tasks/fields');
  }

  public async createTaskField(data: Partial<Field>): Promise<Field> {
    return this.post('/tasks/fields', data);
  }

  public async updateTaskField(
    fieldId: number,
    data: Partial<Field>,
  ): Promise<Field> {
    return this.put(getUrl(fieldId), data);
  }

  public async deleteTaskField(fieldId: number): Promise<Field> {
    return this.delete(getUrl(fieldId));
  }
}

export const TaskFieldsAPI = new TaskFieldsHttpClient();
